<template>
  <div id="app">
    <div id="globalLoading">
      <b-spinner variant="primary" label="Spinning"></b-spinner>
    </div>
    <div class="nav shadow-sm bg-light" v-if="isNavbar" style="z-index: 1038">
      <navbar />
    </div>
    <div :class="{ 'offset-y': isNavbar }">
      <router-view />
    </div>
  </div>
</template>

<script>
import navbar from '@/components/atom/Navbar.vue'
export default {
  name: 'App',
  async created () {
    await this.$store.dispatch('getEnum')
  },
  components: {
    navbar
  },
  computed: {
    isNavbar () {
      return (
        this.$route.name !== '404' &&
        this.$route.name !== '403' &&
        this.$route.name !== '503' &&
        this.$route.name !== 'SignUp' &&
        this.$route.name !== 'Login' &&
        this.$route.name !== 'RegisterByGoogle' &&
        this.$route.name !== 'InvitationHandler'
      )
    },
    sideBarModules () {
      return this.$store.state.modules.moduleList
    },
    route () {
      return this.$route
    },
    deviceType () {
      return this.$store.state.deviceType
    }
  }
}
</script>
<style lang="scss">
:root {
  --navBarHeight: 50px;
  --sideBarWidth: 215px;
}
</style>
<style scoped lang="scss">
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  .nav {
    height: var(--navBarHeight);
    width: 100%;
    position: fixed;
    top: 0;
    padding: 0 10px;
  }
  .padding-left-15px {
    padding-left: 15px;
  }
  .offset-y {
    position: relative;
    top: var(--navBarHeight);
  }
  .TabletStyle {
    padding: 15px 10px 0 10px;
  }
  #globalLoading {
    width: 100vw;
    min-height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    background: rgba(75, 75, 129, 0.363);
    position: absolute;
    z-index: 1000000000;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue